// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

const DocInsights = () => ({
   replace: true,
   templateUrl: '/assets/docInsights.html',
   controller: AvailabilityController,
   controllerAs: 'vm',
})

const AvailabilityBlock = () => ({
   replace: true,
   templateUrl: '/assets/availabilityBlock.html',
   controller: AvailabilityController,
   controllerAs: 'vm',

   bindToController: {
      onDetailPage: '<',
      doc: '<',
      isAiPage: '=',
      availabilityDocs: '<',
      openDetailPage: '&',
      openClickTrackLink: '&',
      contentTypeIcon: '<'
   }
})

class AvailabilityController {
   $scope: any
   availability: any
   availabilityDocs: any
   doc: any
   docService: any
   firstFullTextDisplayText: any
   i18n: any
   isAiPage: any
   isSierraClient: any
   availabilityConfig: any
   onDetailPage: any
   openClickTrackLink: any
   rtaAvailabilityService: any
   showAbbreviatedRTA: any
   translationService: any
   viewStateService: any

   constructor($scope: any, availability: any, translationService: any, config: any, rtaAvailabilityService: any, viewStateService: any, docService: any) {
      this.$scope = $scope
      this.availability = availability
      this.translationService = translationService
      this.rtaAvailabilityService = rtaAvailabilityService
      this.viewStateService = viewStateService
      this.docService = docService
      this.i18n = this.translationService
      this.updateAvailability = this.updateAvailability
      this.availability = this.availability
      this.showFullTextRow = this.showFullTextRow
      this.$scope.linkClickEvent = this.linkClickEvent
      this.isSierraClient = config.data.rtaAvailability.isSierraClient
      this.showAbbreviatedRTA = config.data.rtaAvailability.showAbbreviatedRTA
      this.availabilityConfig = config.data.availability

      this.setDefaultValuesForDirectiveVariables()
      this.$scope.$on('$destroy', () => {
         return this.availability.off('update', this.$scope.$id)
      })
      // @ts-ignore arguments not right type
      this.availability.on('update', this.$scope.$id, (...args) => { return this.updateAvailability.apply(this, args) })
   }


   // this function is repeated in traAvailabilityDirective.ts, availabilityDirective.ts and resultsFeedDirective.ts - i tried to make this a gloabl 
   // function but ran into annoying infinite digest loops which would crash the UI.
   getCombinedContentTypes(doc: any) {
      if (!doc || !doc.content_type) return ''
      const types: string[] = []
      
      types.push(this.translationService.translate(doc.content_type))
      
      if (doc.additional_content_types && doc.additional_content_types.length > 0) {
         doc.additional_content_types.forEach((type: string) => {
            types.push(this.translationService.translate(type))
         })
      }
      
      return types.join(' / ')
   }

   showFullTextRow (firstIteration: any, contentType: any) {
      if (!firstIteration) {
         return this.$scope.avDocs[contentType].fulltext
      }
      return this.$scope.avDocs[contentType].fulltext || ((this.$scope.displayPdfQuickLinks && this.doc.link_to_pdf))
   }

   // called in callback event from availabilityService
   updateAvailability (availabilityIds: any) {
      if (availabilityIds == null || availabilityIds.length == 0) { return }

      const findRtaDocs = (contentType: any) => {
         return _.filter(this.$scope.avDocs[contentType].physical, function(possibleRtaDoc: any) {
            if (possibleRtaDoc.type !== "rta") { return false }
            return availabilityIds.includes(possibleRtaDoc.doc.availability_id)
         })
      }

      let rtaDocs: any = []
      _.each(this.$scope.contentTypes, (contentType: any) => rtaDocs = [... rtaDocs.concat(findRtaDocs(contentType))])
      _.each(rtaDocs, (rtaDoc: any) => {
         // the 'getAvailability' method returns a 'null' availabilities property if it can't find the availability_id;
         // if availabilities is 'null', we show availability information already present, or for 'sierra customers', mark availability as unknown
         rtaDoc.availability = this.availability.getAvailability(rtaDoc.doc.availability_id)
         rtaDoc.availabilities = rtaDoc.availability.availabilities
         rtaDoc.error = rtaDoc.availability.error
         return rtaDoc.loaded = true
      })

      // set rtaLoaded to true locally (to avoid adding spinner back when global status is toggled)
      return this.$scope.rtaLoaded.loaded = true
   }


   linkClickEvent(link: any) {
      return this.openClickTrackLink(link)
   }

   hasRtaDocs(contentType: any) {
      return _.some(this.$scope.avDocs[contentType].physical, (possibleRtaDoc: any) => possibleRtaDoc.type === "rta")
   }

   $onChanges(changesObj: any) {
      if (changesObj.doc && !changesObj.doc.isFirstChange()) {
         this.setDefaultValuesForDirectiveVariables()
         return this.prepareAvailabilityInfoForRender()
      }
   }

   $onInit() {
      return this.prepareAvailabilityInfoForRender()
   }

   // Put any defaults here that would need to be re-calculated from a default starting value if the doc changed
   setDefaultValuesForDirectiveVariables() {
      this.firstFullTextDisplayText = ""
      this.$scope.avDocs = {}
      this.$scope.settings = {}
      // clone global rtaLoaded status
      this.$scope.rtaLoaded = _.clone(this.availability.rtaLoaded) || {}
      if(!this.availabilityConfig.hasRTA){
         this.$scope.rtaLoaded.loaded = true
      }
      this.$scope.contentTypes = []
      this.$scope.contentTypesHaveRta = {}
      this.$scope.showMore = false
      return this.$scope.additionalFullTextLinks = []
   }

   prepareAvailabilityInfoForRender() {
      this.$scope.contentTypes.splice(0, this.$scope.contentTypes.length)
      this.$scope.onDetailPage = this.onDetailPage
      this.$scope.isAiPage = this.isAiPage

      const processDocAndAddToType = (doc: any, linkAttribute = "") => {
         let firstFullTextFound = false
         const avDoc = {};
         // @ts-expect-error TS(2339) FIXME: Property 'type' does not exist on type '{}'.
         [avDoc.type, avDoc.displayText, avDoc.callNumDeweyText, avDoc.callNumDeweyTextOnFail, avDoc.linkInfo, avDoc.additionalLinkInfo, avDoc.provider] =
         this.availability.getAvailabilityInfo(doc)
         // add original document
         // @ts-expect-error TS(2339) FIXME: Property 'doc' does not exist on type '{}'.
         avDoc.doc = doc
         // @ts-expect-error TS(2339) FIXME: Property 'link' does not exist on type '{}'.
         avDoc.link = doc[linkAttribute || "link"]

         // check to see if we already have the doc availability;
         // if not, wait for update from results feed by hooking into the availabilityService
         // @ts-expect-error TS(2339) FIXME: Property 'availability' does not exist on type '{}... Remove this comment to see the full error message
         avDoc.availability = doc.availability || this.availability.getAvailability(doc.availability_id)
         // @ts-expect-error TS(2339) FIXME: Property 'availabilities' does not exist on type '... Remove this comment to see the full error message
         avDoc.availabilities = avDoc.availability.availabilities || []
         // @ts-expect-error TS(2339) FIXME: Property 'error' does not exist on type '{}'.
         avDoc.error = avDoc.availability.error
         // @ts-expect-error TS(2339) FIXME: Property 'loaded' does not exist on type '{}'.
         avDoc.loaded = avDoc.availabilities.length || avDoc.error

         // store the avDocs per 'content type' and 'link design type', so they can be displayed in different parts of the template
         // @ts-expect-error TS(2339) FIXME: Property 'doc' does not exist on type '{}'.
         const contentTypeKey = avDoc.doc.content_type.toLowerCase()

         let linkDesignType = ""
         // @ts-expect-error TS(2339) FIXME: Property 'type' does not exist on type '{}'.
         if (avDoc.type === "fulltext") {
            linkDesignType = "fulltext"
            if (!firstFullTextFound) {
               firstFullTextFound = true
               // @ts-expect-error TS(2339) FIXME: Property 'firstFullText' does not exist on type '{... Remove this comment to see the full error message
               avDoc.firstFullText = true
               // @ts-expect-error TS(2339) FIXME: Property 'displayText' does not exist on type '{}'... Remove this comment to see the full error message
               this.firstFullTextDisplayText = avDoc.displayText
            }
         } else {
            linkDesignType = "physical"
         }

         if (this.$scope.avDocs[contentTypeKey]) {
            if (this.$scope.avDocs[contentTypeKey][linkDesignType]) {
               return this.$scope.avDocs[contentTypeKey][linkDesignType].push(avDoc)
            } else {
               return this.$scope.avDocs[contentTypeKey][linkDesignType] = [avDoc]
            }
         } else {
            this.$scope.contentTypes.push(contentTypeKey)
            this.$scope.avDocs[contentTypeKey] = {}
            return this.$scope.avDocs[contentTypeKey][linkDesignType] = [avDoc]
         }
      }

      // availability docs are actual 'normal' docs + peer_docs
      //  (so there can be more docs then there are records in the result list)
      const buildAvailDocs = (docs: any) => {
         this.$scope.avDocs = {}
         _.each(docs, (doc: any) => {
            if(doc.link_to_html && this.$scope.displayHtmlQuickLinks && (doc.link_to_html !== doc.link)) {
               processDocAndAddToType(doc, "link_to_html")
            }
            return processDocAndAddToType(doc)
         })

         this.handleAdditionalLinks()
         return _.each(this.$scope.contentTypes, (contentType: any) => {
            return this.$scope.contentTypesHaveRta[contentType] = this.hasRtaDocs(contentType)
         })
      }

      if (!this.availabilityDocs?.length) {
         if (this.$scope.onDetailPage) {
            return this.$scope.$watch('availabilityDocs', buildAvailDocs, true)
         } else {
            return buildAvailDocs(this.availabilityDocs)
         }
      } else {
         return buildAvailDocs(this.availabilityDocs)
      }
   }

   handleAdditionalLinks() {
      if (!this.$scope.displayMultipleFullTextLinks) {
         return
      }

      this.deduplicateLinks()
      this.formatAdditionalLinks()
      return this.addOpenUrlIfAppropriate()
   }

   addOpenUrlIfAppropriate() {
      if (this.$scope.displayLinkResolver && this.doc.open_url && (this.$scope.maximumFullTextLinks > this.$scope.additionalFullTextLinks.length)) {
         const link = this.docService.getLinkResolver(this.doc)
         return this.$scope.additionalFullTextLinks.push(this.availability.formatLinkResolver(link))
      }
   }

   formatAdditionalLinks() {
   // If multiple full text links should be shown,
   // assure array is at most as long as the max allowed
      if (this.doc.summon_additional_links?.length) {
         // Collect dbids from the document and its peer documents to identify genuine IEDL links.
         // An OpenURL Link Rule entry (SUM-103316 workaround) has a dbid NOT in the document's own database list.
         const docsToInspect  = [this.doc, ...(this.doc.peer_documents || [])];

         const docDbids = _.flatten(_.map(docsToInspect , (doc: any) => doc.databases || [])).map((db: any) => db.dbid)

         return _.each(this.doc.summon_additional_links.slice(0, +this.$scope.maximumFullTextLinks + 1 || undefined), (link: any) => {
            // Inherit display text from first full text link since content type of additional links is unknown
            const isIedlLink = !link.dbid || docDbids.includes(link.dbid)
            return this.$scope.additionalFullTextLinks.push(this.availability.formatAdditionalLink(this.firstFullTextDisplayText, link, isIedlLink))
         })
      }
   }

   deduplicateLinks() {
      if (!this.doc.summon_additional_links?.length) {
         return
      }
      const self = this
      return this.doc.summon_additional_links = _.filter(this.doc.summon_additional_links,
         (link: any) =>
            _.every(self.$scope.contentTypes,
               (type: any) => link.provider_name !== self.$scope.avDocs[type].fulltext?.[0].provider)
      )
   }
}


AvailabilityController.$inject = ['$scope', 'availabilityService', 'translationService', 'configService', 'rtaAvailabilityService', 'viewStateService', 'documentService']



angular.module('summonApp.directives')
   .controller('availabilityController', AvailabilityController)
   .directive('availabilityBlock', AvailabilityBlock)
   .directive('docInsights', DocInsights)